import { cooperplaceApi } from 'services/api';

export async function getCustomInputValue(search, searchType) {
  try {
    const response = await cooperplaceApi.get(`blacklist/search`, {
      params: {
        search,
        searchType
      },
    });
    return [response.data];
  } catch (err) {
    return []
  }
}

export const formatLabelLog = (type) => {
  switch (type) {
    case 'SHIPPING_COMPANY_BLACKLIST':
      return 'Transportadora'
    case 'VEHICLE_BLACKLIST':
      return 'Veículo'
    case 'DRIVER_BLACKLIST':
      return 'Motorista'
    case 'IMPLEMENT_BLACKLIST':
      return 'Implemento'
    case 'CLIENT_TAKER_BLACKLIST':
      return 'Cliente Tomador'
    default:
      return null
  }
}

export const formatNameCard = (blacklistItem) => {
  switch (blacklistItem?.blacklistType?.slug) {
    case 'SHIPPING_COMPANY_BLACKLIST':
    case 'CLIENT_TAKER_BLACKLIST':
    case 'DRIVER_BLACKLIST':
      return blacklistItem?.person?.label || null
    case 'VEHICLE_BLACKLIST':
      return blacklistItem?.vehicle?.plate || null
    case 'IMPLEMENT_BLACKLIST':
      return blacklistItem?.wagon?.plate || null
    default:
      return null
  }
}

export const formatLink = (blacklistItem) => {
  switch (blacklistItem?.blacklistType?.slug) {
    case 'SHIPPING_COMPANY_BLACKLIST':
      return `/transportadoras/${blacklistItem?.person?.id}`
    case 'VEHICLE_BLACKLIST':
      return `/veiculos/${blacklistItem?.vehicle?.id}`
    case 'DRIVER_BLACKLIST':
      return `/motoristas/${blacklistItem?.person?.id}`
    case 'IMPLEMENT_BLACKLIST':
      return `/implementos/${blacklistItem?.wagon?.id}`
    case 'CLIENT_TAKER_BLACKLIST':
      return `/clientes/${blacklistItem?.person?.id}`
    default:
      return null
  }
}

export const formatOptionInput = (option, blacklistType) => {
  switch (blacklistType) {
    case 'SHIPPING_COMPANY_BLACKLIST':
    case 'CLIENT_TAKER_BLACKLIST':
    case 'DRIVER_BLACKLIST':
      return option?.label || null
    case 'VEHICLE_BLACKLIST':
    case 'IMPLEMENT_BLACKLIST':
      return option?.plate || null
    default:
      return null
  }
}

export const formatInputValue = (data, blacklistType) => {
  switch (blacklistType) {
    case 'SHIPPING_COMPANY_BLACKLIST':
    case 'CLIENT_TAKER_BLACKLIST':
    case 'DRIVER_BLACKLIST':
      return data?.person || null
    case 'VEHICLE_BLACKLIST':
      return data?.vehicle || null
    case 'IMPLEMENT_BLACKLIST':
      return data?.wagon || null
    default:
      return null
  }
}

export const formatOnChange = (value, blacklistType) => {
  switch (blacklistType) {
    case 'SHIPPING_COMPANY_BLACKLIST':
    case 'CLIENT_TAKER_BLACKLIST':
    case 'DRIVER_BLACKLIST':
      return {
        person: value,
        wagon: null,
        vehicle: null
      }
    case 'VEHICLE_BLACKLIST':
      return {
        vehicle: value,
        person: null,
        wagon: null
      }
    case 'IMPLEMENT_BLACKLIST':
      return {
        wagon: value,
        vehicle: null,
        person: null
      }
    default:
      return {
        person: null,
        wagon: null,
        vehicle: null
      }
  }
}
